import React from 'react'
import { useParams } from 'react-router'

import { ReactComponent as HoldIcon } from 'assets/svg/dialpad/hold.svg'
import { ReactComponent as MuteIcon } from 'assets/svg/dialpad/mute.svg'
import { ReactComponent as AddIcon } from 'assets/svg/dialpad/add.svg'
import { ReactComponent as KeypadIcon } from 'assets/svg/dialpad/keypad.svg'
import { ReactComponent as TransferIcon } from 'assets/svg/dialpad/transfer.svg'
import { ReactComponent as LeadIcon } from 'assets/svg/dialpad/lead.svg'
import { ReactComponent as SwapIcon } from 'assets/svg/dialpad/swap.svg'
import { ReactComponent as MergeIcon } from 'assets/svg/dialpad/merge.svg'
import { ReactComponent as ConfirmIcon } from 'assets/svg/dialpad/confirm.svg'
import { ReactComponent as RecordIcon } from 'assets/svg/dialpad/record.svg'

import { ActionCallButton } from 'components/pages/dialpad/components/ActionCallButton'
import { CallPageTypes } from 'common/Enums'
import { useTranslation } from 'react-i18next'
import { IsConferenceDisabled } from 'common/Globals'

export default function CallActions(props) {
    const {
        currentCall = {},
        isOnTransfer = false,
        onHoldHandler = () => {},
        onMuteMicHandler = () => {},
        onSwapHandler = () => {},
        onTransferHandler = () => {},
        onAddHandler = () => {},
        onMergeHandler = () => {},
        onConfirmTransferHandler = () => {},
        onManageConferenceHandler = () => {},
        onRecordingToggleHandler = () => {},
        onKeypadHandler = () => {},
        recordingDisabled = false,
        showRecordingButton = false
    } = props
    const { slug } = useParams()
    const { isCalling, isFinished, isHold, isMuteMic, isTrying, isConference } = currentCall
    const isDisabled = isFinished || isCalling || isTrying
    const isPairCall = slug === CallPageTypes.Multi
    const { t } = useTranslation()

    return (
        <div className="call__actions w-100">
            <div className="call__actions--row d-flex justify-content-between mb-4">
                <ActionCallButton
                    action={onHoldHandler}
                    icon={HoldIcon}
                    text={t('hold')}
                    isActive={isHold}
                    disabled={isDisabled}
                    iconHeight={19}
                />
                <ActionCallButton
                    action={onMuteMicHandler}
                    icon={MuteIcon}
                    text={t('mute')}
                    isActive={isMuteMic}
                    disabled={isDisabled}
                    iconHeight={24}
                />
                {isOnTransfer ? (
                    <ActionCallButton
                        action={onConfirmTransferHandler}
                        icon={ConfirmIcon}
                        text={t('Confirm')}
                        isActive
                        disabled={isDisabled}
                        iconHeight={21}
                    />
                ) : (
                    <ActionCallButton
                        action={onTransferHandler}
                        icon={TransferIcon}
                        text={t('transfer')}
                        disabled={isDisabled || isConference}
                        iconHeight={21}
                    />
                )}
            </div>
            <div className="call__actions--row d-flex justify-content-between">
                {isPairCall ? (
                    <ActionCallButton
                        action={onMergeHandler}
                        icon={MergeIcon}
                        text={t('merge')}
                        disabled={isDisabled || IsConferenceDisabled === 'true'}
                        iconHeight={20}
                    />
                ) : (
                    <ActionCallButton
                        action={onAddHandler}
                        icon={AddIcon}
                        text={t('add')}
                        disabled={isDisabled}
                        iconHeight={24}
                    />
                )}
                {showRecordingButton ? (
                    <ActionCallButton
                        action={onRecordingToggleHandler}
                        icon={RecordIcon}
                        text={recordingDisabled ? t('enable_recording') : t('disable_recording')}
                        isActive={!recordingDisabled}
                        disabled={isDisabled}
                        iconHeight={24}
                    />
                ) : (
                    <ActionCallButton
                        action={onKeypadHandler}
                        icon={KeypadIcon}
                        text={t('keypad')}
                        disabled={isDisabled}
                        iconHeight={19}
                    />
                )}
                {isPairCall ? (
                    <ActionCallButton
                        action={onSwapHandler}
                        icon={SwapIcon}
                        text={t('swap')}
                        disabled={isDisabled}
                        iconHeight={19}
                    />
                ) : (
                    <ActionCallButton
                        action={onManageConferenceHandler}
                        icon={LeadIcon}
                        text={t('manage_conference')}
                        disabled={!isConference}
                        iconHeight={20}
                    />
                )}
            </div>
        </div>
    )
}
